import { twMerge } from 'tailwind-merge'

import { PaymentFrequency } from '../../generated/graphql'
import formatPrice from '../../utils/formatPrice'
import { useQuotation } from '../context'
import cn from '../../utils/cn'

import { Loader } from '@olino/design-system'

type FormattedPriceProps = {
  size: 'sm' | 'lg'
  originalAmount?: number | null
  paymentFrequency?: PaymentFrequency | null
  discountedAmount?: number | null
  hideLoader?: boolean
  taxe?: boolean
}

export const FormattedPrice = ({
  size,
  originalAmount,
  paymentFrequency,
  discountedAmount,
  hideLoader,
  taxe,
}: FormattedPriceProps) => {
  const { isUpdating } = useQuotation()

  return (
    <div
      className={twMerge(
        'relative text-primary-950',
        size === 'sm' ? 'text-xl md:text-2xl' : 'text-3xl md:text-4xl'
      )}
    >
      {!hideLoader && (
        <Loader
          className={twMerge('absolute inset-0', isUpdating ? 'visible' : 'invisible')}
          size={size === 'sm' ? 'small' : 'big'}
        />
      )}

      <div className={cn(!hideLoader && (isUpdating ? 'invisible' : 'visible'))}>
        {!(discountedAmount == null) && (
          <span className="font-bold">
            {formatPrice(
              paymentFrequency === PaymentFrequency.Ponctuel ||
                paymentFrequency === PaymentFrequency.Annually
                ? discountedAmount
                : paymentFrequency === PaymentFrequency.Bimestriel
                ? discountedAmount / 6
                : paymentFrequency === PaymentFrequency.Trimestriel
                ? discountedAmount / 4
                : paymentFrequency === PaymentFrequency.Semestriel
                ? discountedAmount / 2
                : discountedAmount / 12
            )}
          </span>
        )}

        <span
          className={twMerge(
            !(discountedAmount == null)
              ? 'text-sm font-medium text-grey-400 line-through'
              : 'font-bold'
          )}
        >
          {formatPrice(
            paymentFrequency === PaymentFrequency.Ponctuel ||
              paymentFrequency === PaymentFrequency.Annually
              ? originalAmount ?? 0
              : paymentFrequency === PaymentFrequency.Bimestriel
              ? (originalAmount ?? 0) / 6
              : paymentFrequency === PaymentFrequency.Semestriel
              ? (originalAmount ?? 0) / 2
              : paymentFrequency === PaymentFrequency.Trimestriel
              ? (originalAmount ?? 0) / 4
              : (originalAmount ?? 0) / 12
          )}
        </span>

        <span className="text-xs">
          {paymentFrequency === PaymentFrequency.Ponctuel
            ? ''
            : paymentFrequency === PaymentFrequency.Annually
            ? '/an'
            : paymentFrequency === PaymentFrequency.Bimestriel
            ? '/tous les 2 mois'
            : paymentFrequency === PaymentFrequency.Trimestriel
            ? '/tous les 3 mois'
            : paymentFrequency === PaymentFrequency.Semestriel
            ? '/tous les 6 mois'
            : '/mois'}
        </span>

        <span className="font-bold">{!taxe ? '' : ' HT'}</span>
      </div>
    </div>
  )
}
